import type { FC } from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import {
  MissingSignalSource,
  SignalSourceLine,
} from '@/features/signals/components/SignalSourceLine';
import type { SignalSource } from '@/features/signals/type/SignalsTypes';

interface MLSignalSourceStepProps {
  machineSelected: boolean;
  /** The selected machine's signal source, null when it has none. */
  source: SignalSource | null;
  /** False when the source's state (live topics, history) could not be read. */
  statusKnown: boolean;
}

/** Step 2: where the prediction reads the machine's signals, set in Workshop → Machines. */
export const MLSignalSourceStep: FC<MLSignalSourceStepProps> = ({
  machineSelected,
  source,
  statusKnown,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-1.5" data-testid="ml-signal-source-step">
      <div className="flex items-center gap-2">
        <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-primary text-2xs font-semibold text-primary-foreground">
          2
        </span>
        <span className="text-sm font-medium text-foreground">
          {t('mlRul.context.signalSourceLabel')}
        </span>
      </div>
      {!machineSelected && (
        <p className="text-xs text-muted-foreground">{t('mlRul.context.signalSourcePending')}</p>
      )}
      {machineSelected && source && (
        <SignalSourceLine source={source} showTags={statusKnown} showLabel={false} />
      )}
      {machineSelected && !source && (
        <MissingSignalSource message={t('mlRul.context.signalSourceMissing')} />
      )}
    </div>
  );
};
